// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2HLmd","visuallyhidden":"_1IFae","hide-text":"_3fTw3","center":"_3WL5e","noprint":"_1T6sd","root":"_4KS1F","tip-list":"_3iglv","title":"_1R9s2"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-contact-us/styles/default.scss
 ** module id = 993
 ** module chunks = 2
 **/